/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListCourseModuleData } from './genericApiResponseListCourseModuleData';
import type { GenericApiResponseListCourseModuleMessage } from './genericApiResponseListCourseModuleMessage';
import type { GenericApiResponseListCourseModulePagination } from './genericApiResponseListCourseModulePagination';
import type { GenericApiResponseListCourseModuleError } from './genericApiResponseListCourseModuleError';

export interface GenericApiResponseListCourseModule {
  data?: GenericApiResponseListCourseModuleData;
  message?: GenericApiResponseListCourseModuleMessage;
  pagination?: GenericApiResponseListCourseModulePagination;
  error?: GenericApiResponseListCourseModuleError;
  statusCode?: number;
}
